import {
    getAPIGatewayPostRequest,
    getNodeId,
    isResponseCode5xx,
    logOperationalMetric
} from "../../../util/Util";
import {
    ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES,
    CART_RESOURCE_TYPE,
    DEFAULT_PERCENTILE,
    SBL_DASHBOARD_METRIC_PROCESS_NAME,
    METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES,
    RESOURCE_DYNAMIC_ATTRIBUTES_KEY,
    HTTP_STATUS,
    SBL_DASHBOARD_ACTIONS
} from "../../../util/Constants";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

export function initStationConfig(dispatcher) {
    dispatcher({type: SBL_DASHBOARD_ACTIONS.RECEIVE_CONFIG, data: DEFAULT_PERCENTILE});
}

export async function fetchSBLDashboardData(dispatcher) {

    const startTime = Date.now();
    try {
        const request = {
            nodeId: getNodeId(),
            resourceType: CART_RESOURCE_TYPE
        };
        const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES);
        const response = await getAPIGatewayDataFromParent(args);

        if (response.status === HTTP_STATUS.OK) {
            logOperationalMetric(startTime, SBL_DASHBOARD_METRIC_PROCESS_NAME, METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES, true, false);
            const data = (response.data && response.data[RESOURCE_DYNAMIC_ATTRIBUTES_KEY]) || [];
            dispatcher({type: SBL_DASHBOARD_ACTIONS.RECEIVE_DATA, data});
        } else {
            const isFault = isResponseCode5xx(response.status);
            console.error("fetchSBLDashboardData failed with status:", response.status);
            logOperationalMetric(startTime, SBL_DASHBOARD_METRIC_PROCESS_NAME, METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES, false, isFault);
            dispatcher({type: SBL_DASHBOARD_ACTIONS.RECEIVE_ERROR, data: "Failed to load cart data. Please try refreshing."});
        }
    } catch (e) {
        console.error("fetchSBLDashboardData exception:", e);
        logOperationalMetric(startTime, SBL_DASHBOARD_METRIC_PROCESS_NAME, METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES, false, true);
        dispatcher({type: SBL_DASHBOARD_ACTIONS.RECEIVE_ERROR, data: "Failed to load cart data. Please try refreshing."});
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/network/SBLDashboardNetworkAPI.js